(function () {

    // hide payment options on payment method selection
    var $plans = $('.js-payment-plan');
    var $options = $('.js-payment-option');
    if (!$plans.length || !$options.length) return false;

    $plans.each(function () {
        var $plan = $(this);
        if ($plan.is(':checked')) {
            changeOptionsState($plan)
        }
    });

    $plans.on('change', function () {
        var $plan = $(this);
        changeOptionsState($plan);
    });

    function changeOptionsState($plan) {
        var hide_ids = $plan.data('hideOptionsIds');

        // show options
        $options.show();

        // hide options
        if (typeof hide_ids !== 'undefined') {
            var idsArray = hide_ids.replace(/\s+/g, '').split(',');

            for (var i = 0; i < idsArray.length; i++) {
                var id  = idsArray[i];

                $options.each(function () {
                    var $option = $(this);

                    if ($('.js-payment-option-inp', $option).attr('id') === id) {
                        $option.hide();

                        // if hidden option was checked at the moment
                        if ($('.js-payment-option-inp', $option).prop( "checked" )) {
                            $options.filter(':visible').eq(0).find('.js-payment-option-inp').prop('checked', true)
                        }
                    }
                });
            }
        }
    }

})();